import { greatestCommonDivisor } from '@deltasierra/utilities-math';

export class AspectRatio {
    private constructor(
        public readonly width: number,
        public readonly height: number,
        public readonly widthRatio: number,
        public readonly heightRatio: number,
        public readonly stringValue: string,
    ) {}

    public get ratio(): number {
        return this.widthRatio;
    }

    public static of(width: number, height: number): AspectRatio {
        const gcd = greatestCommonDivisor(width, height);

        const aspectWidth = width / gcd;
        const aspectHeight = height / gcd;

        return new AspectRatio(
            aspectWidth,
            aspectHeight,
            aspectWidth / aspectHeight,
            aspectHeight / aspectWidth,
            `${aspectWidth}/${aspectHeight}`,
        );
    }
}
